/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-11-25 10:41:34
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-11-29 19:25:31
 * @FilePath: \ioc_base\src\modules\videoMonitoring\api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 配置接口地址
export const api = {
  // 获取摄像机区域树
  queryCameraTree: "/bms/device/queryDeviceWorkGroupDeviceTree.json",
  // 获取摄像机设备组
  queryCameraList: "/vas/video/queryRegionalEquipmentTree.json",
  // 云台控制
  ptcControl: "/VIID/ptz/ctrl",
  ptcStart: "/VIID/ptz/start",
  ptcRelese: "/VIID/ptz/release",
  // 本地抓拍
  localSnap: "/vas/video/localSnap.json",
  // 一键抓拍
  localSnapList: "/vas/video/localSnapList.json",
  // 查询实时视频播放地址
  queryRealTimeVideoRtsp: "/vas/video/queryRealTimeVideoRtsp.json",
  // 查询录像列表
  queryVideoTimeList: "/vas/video/queryVideoTimeList.json",
  // 查询录像流
  queryPlayBackVideoRtsp: "/vas/video/queryPlayBackVideoRtsp.json",
  // 新建文件夹
  addFolder: "/vas/video/addFolder.json",
  // 修改文件夹
  updateFolder: "/vas/video/updateFolder.json",
  // 删除文件夹
  deleteFolder: "/vas/video/deleteFolder.json",
  // 查询文件夹列表
  queryFolderList: "/vas/video/queryFolderList.json",
  // 查询文件夹详情
  queryFolderDetail: "/vas/video/queryFolderDetail.json",
  // 设置监控点(新增/修改)
  setMonitorPoints: "/vas/video/setMonitorPoints.json",
  // 删除监控点
  deleteFolderOrMonitorPoint: "/vas/video/deleteFolderOrMonitorPoint.json",
  //新增视频轮巡:
  addVideoTour: "/vas/video/addVideoTour.json",

  //修改视频轮巡:
  updateVideoTour: "/vas/video/updateVideoTour.json",
  //新增视频轮巡场景:
  addVideoTourScene: "/vas/video/addVideoTourScene.json",
  //修改视频轮巡场景:
  updateVideoTourScene: "/vas/video/updateVideoTourScene.json",
  //查询轮巡及场景及摄像机:
  queryVideoTour: "/vas/video/queryVideoTour.json",
  //删除视频轮巡:
  deleteVideoTour: "/vas/video/deleteVideoTour.json",
  //删除视频轮巡场景:
  deleteVideoTourScene: "/vas/video/deleteVideoTourScene.json"
};
